import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { Typography, Flex } from '@jisr-hr/ds'
import I18n from 'translations/i18n'
import Avatar from '@material-ui/core/Avatar'
import { UserLoader } from 'components/global/molecules/Loaders'
import { ReactComponent as BackArrow } from 'assets/figma-icons/Back-Arrow.svg'
import { labels } from 'utils/whitelabel'
import LoginContent from './loginContent'
import './style.css'

const LoginTemplate = ({ company, hideHeader, children, hideBackLink }) => {
  const { location, push } = useHistory()
  const isMaken = labels.name === 'Maken'

  return (
    <section className="login-box">
      <LoginContent />
      <div className="login--form-box">
        <div className="form-container">
          {!hideBackLink && location.pathname !== '/login' && (
            <Typography
              variant="subtitle-2"
              onClick={() => push('/login')}
              className="back-link"
              text={
                <>
                  <BackArrow style={{ marginInlineEnd: 7 }} />
                  <span>{I18n.t('login')}</span>
                </>
              }
            />
          )}
          {!hideHeader && (
            <div className="form-header">
              {!company ? (
                <UserLoader />
              ) : (
                <Flex
                  itemsCenter
                  style={{ gap: 10 }}
                >
                  <Avatar
                    alt={company.slug}
                    src={company.logo}
                  />
                  <Typography
                    typography="subtitle-1"
                    data-testid="company-title"
                    text={company.slug}
                  />
                </Flex>
              )}
            </div>
          )}
          {children}
          {isMaken && (
            <div className="maken-logo">
              <img
                src={labels.logo}
                alt={labels.translation_app_name}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

LoginTemplate.propTypes = {
  company: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
  children: PropTypes.node,
  hideHeader: PropTypes.bool,
  hideBackLink: PropTypes.bool,
}

export default LoginTemplate
